/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelText64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelText64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.3799 27.2727V28.2102H23.1242V36H24.181V28.2102H26.9253V27.2727H20.3799ZM28.583 35.7187C29.0404 35.9971 29.5844 36.1363 30.2151 36.1363C30.6583 36.1363 31.0574 36.0682 31.4126 35.9318C31.7677 35.7926 32.066 35.5994 32.3074 35.3523C32.5489 35.1023 32.7208 34.8125 32.8231 34.4829L31.8515 34.2102C31.7662 34.4375 31.6455 34.6278 31.4893 34.7812C31.333 34.9318 31.1469 35.0454 30.931 35.1221C30.7179 35.196 30.4793 35.2329 30.2151 35.2329C29.8089 35.2329 29.4523 35.1449 29.1455 34.9687C28.8387 34.7897 28.5986 34.5298 28.4253 34.1889C28.2708 33.8772 28.1863 33.5036 28.1719 33.0682H32.9253V32.642C32.9253 32.0312 32.8444 31.517 32.6824 31.0994C32.5205 30.6818 32.3032 30.3466 32.0304 30.0937C31.7577 29.838 31.4552 29.6534 31.1228 29.5397C30.7904 29.4261 30.4537 29.3693 30.1128 29.3693C29.5219 29.3693 29.0049 29.5142 28.5617 29.804C28.1214 30.0909 27.7776 30.4915 27.5305 31.0057C27.2861 31.517 27.164 32.1079 27.164 32.7784C27.164 33.4488 27.2861 34.0369 27.5305 34.5426C27.7776 35.0454 28.1285 35.4375 28.583 35.7187ZM28.1744 32.1988C28.1936 31.8952 28.2701 31.6083 28.404 31.338C28.5603 31.0227 28.7833 30.767 29.0731 30.571C29.3657 30.3721 29.7123 30.2727 30.1128 30.2727C30.4765 30.2727 30.7918 30.3565 31.0589 30.5241C31.3287 30.6917 31.5361 30.9204 31.681 31.2102C31.8287 31.5 31.9026 31.8295 31.9026 32.1988H28.1744ZM35.0294 29.4545L36.5976 32.1307L38.1657 29.4545H39.3248L37.2112 32.7273L39.3248 36H38.1657L36.5976 33.4602L35.0294 36H33.8703L35.9498 32.7273L33.8703 29.4545H35.0294ZM43.6064 30.3068V29.4545H42.2087V27.8863H41.203V29.4545H40.2144V30.3068H41.203V34.3977C41.203 34.7784 41.2911 35.0937 41.4672 35.3437C41.6462 35.5937 41.8706 35.7798 42.1405 35.902C42.4133 36.0241 42.6917 36.0852 42.9758 36.0852C43.1633 36.0852 43.3181 36.071 43.4403 36.0426C43.5624 36.017 43.6576 35.9915 43.7258 35.9659L43.5212 35.0625L43.3508 35.0966C43.2797 35.1079 43.1888 35.1136 43.078 35.1136C42.9303 35.1136 42.7897 35.0909 42.6562 35.0454C42.5255 34.9971 42.4175 34.9034 42.3323 34.7642C42.2499 34.6221 42.2087 34.4091 42.2087 34.125V30.3068H43.6064Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelText64Icon.tags = ['text', 'add', 'document', 'note', 'writing'];

AddPanelText64Icon.category = '64x64 (Add panel)';

AddPanelText64Icon.iconSize = 64;
